export default "__VITE_ASSET__DWximJux__"